import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type WarehouseInventoryBlocksDTO = {
  warehouse_ids: string[]
}

export const WarehouseOperationBlocksApi = {
  getInventoryBlockedWarehouses:
    (): CancelablePromise<WarehouseInventoryBlocksDTO> =>
      __request(OpenAPI, {
        method: "GET",
        url: "/v1/warehouse/inventory-blocks",
      }),
}
